const copywritings = {
  increase: [
    {
      sentence: '带着一身灵动的五花肉挤进了被窝，瞬间升温',
    },
    {
      sentence: '蛇皮走位快速挤进被窝一角，被窝立马飙升了',
    },
    {
      adj: '峡谷万人迷的',
      sentence: '挤进被窝，大家心跳加快，温度一下上升',
    },
    {
      adj: '王者操作的',
      sentence: '刚进被窝就主宰了比赛，被窝一下飙升',
    },
  ],
  decrease: [
    {
      adj: '连跪的',
      sentence: '钻进被窝，被窝瞬间降低了',
    },
    {
      adj: '没穿秋裤的',
      sentence: '一进被窝，被窝立马凉了',
    },
    {
      adj: '双脚冰凉的',
      sentence: '上辈子是折翼的天使，一进被窝就降低了',
    },
  ],
}

export default copywritings
